/* unplugin-vue-components disabled */import { render } from "./ContactTip.vue?vue&type=template&id=5498c5a9&scoped=true&ts=true"
import script from "./ContactTip.vue?vue&type=script&lang=ts"
export * from "./ContactTip.vue?vue&type=script&lang=ts"

import "./ContactTip.vue?vue&type=style&index=0&id=5498c5a9&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgy-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5498c5a9"]])

export default __exports__